<template>
  <div class="container">
    <content-header :data="[{text:'抽奖活动一览', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <router-link to="/lottery/new">
            <el-button type="primary" icon="plus" v-permission="['lottery.create']">添加</el-button>
          </router-link>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="请输入名称关键字"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-entry">
          <el-select v-model="status" clearable value-key="id" placeholder="请选择状态" @change="searchHandle">
            <el-option
              v-for="item in statusIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="search-entry">
          <span>抽奖活动创建时间</span>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="dateChange"
            :picker-options="datePickerOptions">
          </el-date-picker>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="id"
            label="抽奖活动编号"
            width="100"
            fixed>
          </el-table-column>
          <el-table-column
            prop="name"
            label="抽奖活动名称"
            width="200"
            fixed>
          </el-table-column>
          <el-table-column
            label="封面图">
            <template slot-scope="scope">
            <img style="width:50px;height:50px" :src="domainPic + scope.row.image" v-if="scope.row.image" />
            </template>
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="活动开始时间"
            width="180">
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="活动结束时间"
            width="180">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态">
          </el-table-column>
          <el-table-column
            prop="openCount"
            label="已抽奖人次">
          </el-table-column>
          <el-table-column
            prop="created"
            label="创建时间"
            width="180">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small" v-permission="['lottery.update']">修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" v-permission="['lottery.delete']">删除</el-button>
              <el-button @click="initPrizeHandle(scope)" type="text" size="small" >奖品</el-button>
              <el-button @click="downloadHandle(scope)" type="text" size="small" v-permission="['lottery.qrcode']">下载二维码</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import LotteryModel from 'models/lottery'
  import permission from 'directive/permission/index.js'

  export default {
    directives: { permission },
    data () {
      return {
        domainPic: constants.basic.domain_pic,
        keywords: '',
        tableData: [],
        curPage: 1,
        pageSize: 10,
        total: 0,
        status: '',
        statusIds: [{id: '1', name: '未开始'}, {id: '2', name: '进行中'}, {id: '3', name: '已结束'}],
        startDate: '',
        endDate: '',
        dateRange: '',
        datePickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
      }
    },
    created () {
      this.getObjList()
    },
    methods: {
      //
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          keywords: this.keywords,
          status: this.status,
          startDate: this.startDate,
          endDate: this.endDate
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        LotteryModel.find(_opts).then(res => {
          for (let i = 0; i < res.rows.length; i++) {
            let start = new Date(res.rows[i].startTime.replace(/-/g, '/'))
            let end = new Date(res.rows[i].endTime.replace(/-/g, '/'))
            let now = new Date()
            if (start > now) {
              res.rows[i].status = '未开始'
            } else if (start <= now && now <= end) {
              res.rows[i].status = '进行中'
            } else {
              res.rows[i].status = '已结束'
            }
          }
          this.tableData = res.rows
          this.total = res.total
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            LotteryModel.delete({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      initEditHandle (item) {
        this.$router.push({
          name: 'lottery.new',
          query: { id: item.row.id }
        })
      },
      initPrizeHandle (item) {
        this.$router.push({
          name: 'lottery.prize.manage',
          query: { id: item.row.id, name: item.row.name }
        })
      },
      searchHandle () {
        this.getObjList()
      },
      downloadHandle (item) {
        this.$router.push({
          name: 'redenvelope.qrcode',
          query: {redEnvelopeId: item.row.id, type: 1}
        })
      },
      dateChange (value) {
        if (value) {
          this.startDate = value[0]
          this.endDate = value[1]
        } else {
          this.startDate = ''
          this.endDate = ''
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
      .check-title
        text-align: right
        display: inline-block
        vertical-align: middle
        width: 90px
        font-size: 14px
        color: #48576a
        line-height: 1
        padding: 11px 12px 11px 0
        box-sizing: border-box
      .avatar-uploader
          border: 1px dashed #d9d9d9
          border-radius: 6px
          cursor: pointer
          position: relative
          overflow: hidden
          width: 180px
          &:hover
            border-color: #409EFF
          .avatar-uploader-icon
            font-size: 28px
            color: #8c939d
            width: 178px
            height: 178px
            line-height: 178px
            text-align: center
          .avatar
            width: 178px
            height: 178px
            display: block
</style>



// WEBPACK FOOTER //
// src/views/Lottery.vue